import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [["", "Home"], ["/details", "Details"], ["/gallery", "Gallery"], ["/sponsors", "Sponsors"]];
const navHref = (base, path, qs) => `${base}${path}${qs}`;

export function ListingHeader({ slug, brandLabel, preview, onRequestShowing, onMenuOpenChange }) {
  const [open, setOpenState] = useState(false);
  const setOpen = (next) => { setOpenState(next); onMenuOpenChange?.(next); };
  const { pathname } = useLocation();
  const base = `/listing/${slug}`;
  const qs = preview ? "?preview=1" : "";
  const isActive = (path) => pathname === `${base}${path}`;

  return (
    <header data-testid="listing-header" className="sticky top-0 z-40 h-16 sm:h-[72px] bg-[#111820] border-b border-white/10">
      <div className="mx-auto max-w-[1360px] h-full px-4 sm:px-6 lg:px-10 flex items-center justify-between gap-4">
        <Link to={`${base}${qs}`} data-testid="listing-header-brand" className="font-serif-display text-white text-base sm:text-lg truncate max-w-[50%] sm:max-w-none">{brandLabel}</Link>
        <nav className="hidden md:flex items-center gap-7 text-xs font-medium uppercase tracking-[0.12em] text-white/75">
          {NAV.map(([path, label]) => (
            <Link key={label} to={navHref(base, path, qs)} data-testid={`listing-nav-${label.toLowerCase()}`} className={`hover:text-white transition-colors ${isActive(path) ? "text-white" : ""}`}>{label}</Link>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <button data-testid="listing-header-showing-btn" onClick={onRequestShowing} className="hidden sm:inline-flex items-center rounded-full bg-[#C7A361] text-[#111820] text-xs font-semibold uppercase tracking-[0.1em] px-5 py-2.5 hover:brightness-95 transition">Schedule a Showing</button>
          <button data-testid="listing-mobile-menu-btn" onClick={() => setOpen(true)} className="md:hidden text-white p-2 -mr-2"><Menu size={22} /></button>
        </div>
      </div>
      {open && (
        <div data-testid="listing-mobile-menu" className="fixed inset-0 z-50 bg-[#111820] md:hidden">
          <div className="flex items-center justify-between h-16 px-4 border-b border-white/10">
            <span className="text-white font-serif-display">{brandLabel}</span>
            <button data-testid="listing-mobile-menu-close" onClick={() => setOpen(false)} className="text-white p-2 -mr-2"><X size={22} /></button>
          </div>
          <nav className="flex flex-col px-5">
            {NAV.map(([path, label]) => (
              <Link key={label} to={navHref(base, path, qs)} onClick={() => setOpen(false)} data-testid={`listing-mobile-nav-${label.toLowerCase()}`} className="py-4 text-lg text-white border-b border-white/10">{label}</Link>
            ))}
            <button data-testid="listing-mobile-showing-btn" onClick={() => { setOpen(false); onRequestShowing(); }} className="mt-6 rounded-full bg-[#C7A361] text-[#111820] text-sm font-semibold uppercase tracking-[0.1em] py-3.5">Schedule a Showing</button>
          </nav>
        </div>
      )}
    </header>
  );
}
